import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { classIf, getConfiguration } from '../../data/utils';
import { getLabel } from '../../InitData';
import MultiBets from './MultiBets';
import ReservationBox from './ReservationBox';
import SingleBets from './SingleBets';
import SystemBets from './SystemBets';



function Coupon(props) {
	const betslipContext = useContext(BetslipContext) ;
    
	const showable = props.showable;
	const couponKey = props.couponKey;
    let betslipData = betslipContext.getBetslipData();
    const coupon = betslipData.coupons[couponKey];
    const tabAttivo = coupon.selectedContainer;
    const conf = getConfiguration();
    const containerOrder = conf.bco;


	 function clearBetslip() {
    	betslipContext.clearBetslip(couponKey);
    }

    
    function showContainer(container){
//    	betslipData.coupons[couponKey].selectedContainer = container;
    	betslipContext.changeContainer(container);
    }
    
    const showReservationBox = betslipContext.isReservationBoxShown() && !betslipContext.isBetBuilder();

    return (
    	
	<div className={"tabpane fade" + (showable? " active show" : "")} 
	 	 id={"couponNumber" + couponKey}
	 	 role="tabpanel">
		
		{showReservationBox ?
            <ReservationBox couponKey={couponKey} key={"reservation-box-coupon-" + couponKey} />
            :
			<>
			{
				!betslipContext.isBetBuilder() &&
			    <div className="widget-schedina-nav bg-nero bianco maiuscolo nav nav-tabs" role="tablist" id={"nav-coupon-" + couponKey}>
		        {
		        	Object.keys(containerOrder).map(function(key) {
		        		const tabValue = containerOrder[key];
            			const reactKey = "container-" + tabValue + "-coupon-" + couponKey;
            			let label = null;
            			if(tabValue === 'singlebets'){
            				label = betslipContext.addAndBet? getLabel('general.fastbet') : getLabel('general.singola');
            			}
            			else if(tabValue === 'multibets'){
            				label = getLabel('general.multipla');
            			}
            			else {
            				label = getLabel('general.sistemi');
            			}
            			let classList = "tasto-nav-quote-landing padding-verticale" + classIf(tabAttivo === tabValue, 'active');
            			if(betslipContext.addAndBet && tabValue !== 'singlebets'){
            				classList = classList + " d.none";
            			}
            			return (
            			  <a key={reactKey}
            			  	 onClick={() => showContainer(tabValue)} 
         		        	 className={classList} 
         		        	 data-toggle="tab" href={"#NOT-EXIST-container-" + tabValue + "-coupon-" + couponKey} 
         		        	 id={"selector-"+ tabValue + "-coupon-" + couponKey} 
            			  	 role="tab" 
            			  	 aria-controls="profile" 
            			  	 aria-selected="false">
         		          	{label}
         		          </a>
            			)
		        	})
		        }
		        </div>
			}
			{
				!betslipContext.isBetBuilder() &&
					<div className="numero-eventi-segni maiuscolo nero testo-piccolo d-flex justify-content-between position-relative">
				        <div>
	                        <span>{getLabel('carrello.events_number')} {coupon.selections.length }</span> <span>&nbsp;</span> <span>{getLabel('carrello.signs_number')} {coupon.totalDraws}</span>
	                    </div>
						{conf.iwh &&  <button onClick={() => clearBetslip()} className="btn-wh-betslip">{getLabel('carrello.empty_cart')}</button>}
			        </div>
			}

		        <div className="tab-content widget-schedina bg-bianco bordo-tondo-basso-dx bordo-tondo-basso-sx">
		        	{
		        		betslipContext.isBetBuilder()? 
		        		<MultiBets couponKey={couponKey} showable="true"/>
		        		:
		        		<>
			        		{tabAttivo === 'singlebets' && (<SingleBets couponKey={couponKey} showable="true"/>)}
			        		{tabAttivo === 'multibets'  && (<MultiBets couponKey={couponKey} showable="true"/>)}
			        		{tabAttivo === 'systembets' && (<SystemBets couponKey={couponKey} showable="true"/>)}
		        		</>
		        	}

		        </div>			
		    </>	
		}

	</div>)
}

export default Coupon;